module.exports = __webpack_public_path__ + "c826931bdf4b80ec09f4a8660c6fd330.png";